import React, { Component } from 'react';
import Breadcrumb from 'templates/landing-seo/breadcrumb';
import CoverSection from 'templates/landing-seo/cover-section';
import { getContext } from 'services/context';
import { imagify } from 'server/routes/seo/helpers';
import LandingSearchBar from 'templates/landing-seo/search-bar';
import LinksSection from 'templates/landing-seo/links-section';
import propsValidation from 'templates/seo/props-validation';
import renderDynamic from 'templates/seo/render';
import SubMenu from 'templates/landing-seo/sub-menu';

export const DOMAINS_WITHOUT_LINKING = ['.it', '.co.uk'];


class SeoPage extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  renderBreadcrumb() {
    const { breadcrumb } = this.props;
    return breadcrumb ? (<Breadcrumb items={ breadcrumb } />) : null;
  }

  renderCover() {
    const { coverSection, isPagination, pageNumber, numberOfPages, t } = this.props;

    return coverSection ? (
      <CoverSection
        image={ imagify(coverSection.image, 1200) }
        text={ isPagination
          ? t("{text} page {numPage} of {numPages}", { numPage: pageNumber, numPages: numberOfPages, text: coverSection.title.text })
          : coverSection.title.text || coverSection.title }
      />
    ) : null;
  }

  renderSubmenu() {
    const { subMenu } = this.props;
    return subMenu ? (
      <div id="submenu-seo">
        <SubMenu
          handleChange={ () => { } }
          items={ subMenu.sort((a, b) => a.position - b.position) }
          selected={ subMenu && subMenu.length ? subMenu[0].name : null }
        />
      </div>
    ) : null;
  }

  renderModules() {
    const { modules, domain, t } = this.props;
    if (!modules) return null;

    return modules
      .sort((a, b) => a.position - b.position)
      .map((module, i) => renderDynamic(module, i, domain, t));
  }

  renderLinkfarm() {
    const { links, domain } = this.props;
    if (DOMAINS_WITHOUT_LINKING.includes(domain)) return null;
    if (links && links.title && links.data.length) {
      return (
        <LinksSection
          key={ links.title }
          menu={ [links] }
          selected={ links.title }
        />
      );
    }
    return null;
  }

  render() {
    const { adCheckboxes = [] } = this.props;
    return (
      <div className="landing-page">
        <main>
          <article>
            { this.renderBreadcrumb() }
            { this.renderCover() }
            <div id="search-bar">
              <LandingSearchBar adCheckboxes={ adCheckboxes } />
            </div>
            { this.renderSubmenu() }
            { this.renderModules() }
            { this.renderLinkfarm() }
          </article>
        </main>
      </div>
    );
  }
}

SeoPage.propTypes = propsValidation;

export default getContext(SeoPage);
